// extracted by mini-css-extract-plugin
export default {"challengesTable":"xQ3jffW82q46KmNVtKDN"};